import React, { useState, useContext, useReducer } from "react";

import GlobalContext                      from "../../isp._comun/iu/contexto/GlobalContext";
import * as TipoDeError                   from "../../isp._comun/services/Errores";
// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import ServicioDeQueryDeItems             from "../../isp.žapi.items/ServiceQueryItems";


import QueryItemReducer from "../reductores/QueryItemReducer";
import CargaDeItemsBuscados from "../reductores/acciones/dispatch/CargaDeItemsBuscados";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

import DialogoQueryItemsLayout from "./layouts/DialogoQueryItemsLayout";
import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";

const DialogoQueryItems = ({ ventana }) => {
    const { notificar, handleErroresExtraEnPrincipal } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryItemReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: false,
            procesandoBusquedaUnSoloCliente: false,
        },
        // idClienteSelec: null,
    });

    const serviceAPIDeQueryDeItems = new ServicioDeQueryDeItems();
    const buscarItemsCommand = new ComandoAPI(serviceAPIDeQueryDeItems);
    buscarItemsCommand.ejecutar = async (paramsQuery) => {

        try {
            const respuestaQuery = await serviceAPIDeQueryDeItems.ejecutar(paramsQuery);
            dispatchQ(new CargaDeItemsBuscados(respuestaQuery.items));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    }
    

    return (
        <DialogoQueryItemsLayout
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarItems={buscarItemsCommand}
            // buscarItems={buscarItems}
        />
    );
};

export default DialogoQueryItems;
